import { render } from "./appBusiness.vue?vue&type=template&id=61b427dd&scoped=true"
import script from "./appBusiness.vue?vue&type=script&lang=js"
export * from "./appBusiness.vue?vue&type=script&lang=js"

import "./appBusiness.vue?vue&type=style&index=0&id=61b427dd&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-61b427dd"

export default script